"use client";

import { ScrollRevealText } from "@/components/ui/scroll-reveal-text";

interface HomeHeroTitleProps {
  /** Mobile + desktop lead — Figma 4074:23618 appends a period on mobile only. */
  lead: string;
  /** Desktop-only second line (Figma 6032:27581). */
  subtitle: string;
}

/**
 * Homepage hero headline — mobile shows lead only; desktop adds subtitle on
 * a second line. All copy uses solid grey-950 (Figma 6032:27581).
 * Separate ScrollRevealText instances avoid flattening hidden copy into mobile
 * line measurement (same pattern as CareersHeroTitle).
 */
export function HomeHeroTitle({ lead, subtitle }: HomeHeroTitleProps) {
  const mobileLead = lead.endsWith(".") ? lead : `${lead}.`;

  return (
    <>
      <span className="md:hidden">
        <ScrollRevealText variant="light" className="text-balance">
          {mobileLead}
        </ScrollRevealText>
      </span>
      <span className="hidden md:contents">
        <ScrollRevealText variant="light" className="text-balance">
          {lead}
          <br />
          {subtitle}
        </ScrollRevealText>
      </span>
    </>
  );
}
